export const WelcomeSection = () => {
    return (
      <div id="welcome-section">
        <h1>Hey I am Rob.Jason</h1>
        <p>a Freelancer</p>
      </div>
    )
  }

  export default WelcomeSection;